import { EMAIL_DESKTOP_MAX_WIDTH } from "../../../Design/mediaQuery";

export const defaultStyles = {
  borderColor: "#E4E7EB",
  borderWidth: "1px",
  borderStyle: "solid",
  sizing: {
    width: `${EMAIL_DESKTOP_MAX_WIDTH - 64}px`, // 64px is the margin of the container
    height: "auto",
    minWidth: "auto",
    minHeight: "auto",
    maxWidth: `${EMAIL_DESKTOP_MAX_WIDTH}px`, // 64px is the margin of the container
    maxHeight: "auto",
  },
  margin: {
    marginTop: "12",
    marginBottom: "12",
    marginLeft: "32",
    marginRight: "32",
  },
} as const;
